/**
 * TM roles the Orbit staff sync does not manage, so the staff role mapping never offers them. ADMIN is given
 * and taken away by hand in TM: Super Admin and Admin in Orbit map to no access. The editor offers the roles
 * GET api/Maintenance/LeapStaffRoles lists, less these.
 */
export const ROLE_MAP_UNMAPPABLE_CODES: ReadonlyArray<string> = ['ADMIN'];
